import { componentLibraryManager } from "./component.lib";
import { deserializeDiagramComponents } from "./diagram-components.lib";
import { loadLocalFile } from "./file-operations.lib";

interface DiagramLoadOptions {
  handleMissingDependencies: (data: any) => Promise<void>;
  setComponents: (components: any[]) => void;
  setDiagramComponents: (components: any) => void;
  setErrorMessage: (message: string | null) => void;
}

export const loadDiagram = async (
  file: File,
  options: DiagramLoadOptions
): Promise<void> => {
  const {
    handleMissingDependencies,
    setComponents,
    setDiagramComponents,
    setErrorMessage,
  } = options;

  try {
    const loadedData = await loadLocalFile(file);
    const parsedData = JSON.parse(loadedData);

    // Deserialize the loaded data to retrieve diagram components and library information
    const deserializedComponents = deserializeDiagramComponents(
      parsedData.serializedDiagramComponents
    );
    componentLibraryManager.deserializeComponentLib(
      parsedData.serializedComponentLib
    );

    await handleMissingDependencies(parsedData.serializedDiagramComponents);

    setComponents(componentLibraryManager.getAllComponents());
    setDiagramComponents(deserializedComponents);
    setErrorMessage(null);
  } catch (error) {
    console.error("Error loading diagram:", error);
    setErrorMessage(
      error instanceof Error
        ? error.message
        : "Failed to load diagram. Please check the file and try again."
    );
  }
};
